import type { ReactNode } from 'react';
import { usePermission } from '@backstage/plugin-permission-react';
import { sheriffAdminSyncPermission } from '../permissions';

export const SheriffAdminNavGate = ({ children }: { children: ReactNode }) => {
  const { loading, allowed } = usePermission({
    permission: sheriffAdminSyncPermission,
  });

  if (loading || !allowed) {
    return null;
  }

  return <>{children}</>;
};
